<template>
  <component id="main" :is="hasLayout">
    <router-view :key="$route.params.page || ''"/>
  </component>
</template>

<script>

export default {
  name: 'Home',
  computed: {
    hasLayout () {
      const layoutIndex = this.$route.matched.find((route) => route.meta.layout)
      return layoutIndex ? layoutIndex.meta.layout : 'div'
    }
  }
}
</script>

<style lang="scss"></style>
